import {
  Component,
  OnInit
} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit{
  email = 'contact@nestas.eu';
  phone = '+32 499 506070';

  constructor(public translate: TranslateService){

  }

  ngOnInit(){

  }
}
